export default __webpack_public_path__ + "static/media/SAS0120.34I-32497_-18318_0.8970943a.jpg";